import React from 'react';
import { Container, Col, Row } from 'react-bootstrap';

export default function CTFCard(props: any) {
    const [rank, setRank] = React.useState('');
    return (
        <Container
            className='glass CTF CTF__card mb-3'
            onClick={() => {
                window.open(props.ProfileLink, '_blank');
            }}
        >
            <Row className='justify-content-center'>
                <Col
                    xs='auto'
                    sm='auto'
                    md='auto'
                    lg='auto'
                    xl='auto'
                    xxl='auto'
                >
                    <img
                        src={props.Image}
                        alt='profile'
                        className='no-select cert-image CTF__image'
                    />
                </Col>
                <Container
                    style={{
                        background: `rgba(${props.ColorRGB}, 0.534)`,
                    }}
                    className='glass CTF__description'
                >
                    <Col
                        xs='auto'
                        sm='auto'
                        md='auto'
                        lg='auto'
                        xl='auto'
                        xxl='auto'
                    >
                        <h4
                            style={{
                                fontSize: '1.2rem',
                            }}
                            className='text no-select'
                        >
                            {props.Name}
                        </h4>
                    </Col>
                    {!(typeof props.ProfileRank === 'string') &&
                        props.ProfileRank(setRank)}
                    <Col
                        xs='auto'
                        sm='auto'
                        md='auto'
                        lg='auto'
                        xl='auto'
                        xxl='auto'
                    >
                        <h5
                            style={{
                                fontSize: '1rem',
                            }}
                            className='text no-select'
                        >
                            {' '}
                            {!(typeof props.ProfileRank === 'string')
                                ? `Rank: #${rank}`
                                : `Rank: #${props.ProfileRank}`}
                        </h5>
                    </Col>
                </Container>
            </Row>
        </Container>
    );
}
